export default __webpack_public_path__ + "static/media/ag_3.a32d721b.wav";